<template> 
    <div style="background:#fff;   "> 
        <div style=" line-height:30px;margin-top:2px;padding-top:2px;height:38px; display:flex;border-bottom:2px solid #389">        
            <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
            <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:13px;margin-right:15px;">新增记录</span></el-link>
            <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:5px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            
            <el-input placeholder="请输入查询值" ref="refqry" v-model="textparam" size="small" style="width:320px; height:30px; ">
                <el-select slot="prepend" v-model="oper"  size="small" style="width:110px;  ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
            </el-input> 
            <el-select v-model="selparam2"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:5px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            
            <el-input placeholder="请输入查询值" v-model="textparam2" size="small" style="width:320px; height:30px;  ">
                <el-select v-model="oper2" slot="prepend" size="small" style="width:110px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
            </el-input>  

        </div>
        <el-table :data="tmpData" 
                border                            
                disabled-hover
                class="custom-table-border"
                style="overflow:auto;margin-top:3px;"
                v-loading="loading"
                element-loading-background = "rgba(255, 255, 255, .5)"
                element-loading-text = "加载中，请稍后..."
                element-loading-spinner = "el-icon-loading"
                size="small"
                ref="reftab"
                :height="tabHeight" 
                :max-height="tabHeight" 
                :row-key="getRowKey"
                highlight-current-row>
                <el-table-column
                type="index"
                label="序号"
                width="60">
                </el-table-column>
            <span  v-for="(item ,index) in tabCol" :key="index">   
                <el-table-column   v-if="item.thide==='N'"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    sortable
                    :min-width="item.width">
                </el-table-column> 
            </span> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="80">
                <template slot-scope="scope">

                    <i class="iconfont icon-chazhao" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link  @click="editRec(scope.row )" :underline="false"  ><span style="font-size:10px;margin-right:5px;">编辑</span></el-link>
                </template>
            </el-table-column>                       
        </el-table>
 
        <!-- 提示 -->
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
  
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <!-- 数据查看 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="initWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">产品期初数量</span>
            </div> 
            <div style="height:89vh;overflow-y:auto">
            <Form ref="addForm" :model="formCol" :label-width="120"    label-position="right" inline >
                <span v-for="(item,index) in tabCol" :key="index" >
                    <FormItem :class="item.key=='MATDESC'?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-input readonly  type="textarea" :rows="2"  v-else-if="item.key==='MATDESC'"   v-model="formCol[item.key]"></el-input> 
 
                        <el-select filterable @change="matChg" v-else-if="item.key==='MATNO' " v-model="formCol[item.key]"   style="width:100%">
                            <el-row v-for="item in prdArr " :key="item.IDNO">
                                <div :title="item.MATDESC">
                                    <el-col :span="6">
                                        <el-option  :label="item.MATNM" :value="item.IDNO"></el-option>
                                    </el-col>
                                    <el-col :span="14">
                                        <el-option  :label="item.MATDESC" :value="item.IDNO"></el-option>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-option  :label="item.IDNO" :value="item.IDNO"></el-option>
                                    </el-col>
                                </div>
                            </el-row>
                        </el-select>
                        <el-input-number controls-position="right" v-else-if="item.edcss==='number'"  style="width:100%" v-model="formCol[item.key]"></el-input-number> 
                        <el-input :placeholder="item.holder" type="text" v-else  :disabled="item.disabled==='Y'?true:false"  v-model="formCol[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>   
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="initWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
 
export default {
    name: 'sku_initial',
    data () {
        return {
            dataCount:0,
            rowSize:50,
            current:1,
            chkWin:false,
            chkCol:{},
            formCol:{},
            prompt:'', // 
            promptWin:false,
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'ASIN',// select 绑定值
            oper:'like',
            textparam:'', // input 绑定值
            tabCol:[] ,//表列集合
            prdArr:[],
            tmpData:[] ,// 
            selparam2:'',// select 绑定值
            oper2:'like',
            textparam2:'',  
 
            dtlData:[],
            disabled:false,
            impWin:false,
            stkid:'',
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            type:'create',
            stkArr:[],
            operArr:[],
            treeid:'0',
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止 
            v_admin:this.$cookies.get('v_admin') ,//  
            loadWin:false,
            initWin:false,
            allData:[],
        }
    },
    created () {
        this.getTabCol() //得到 表列数组 
        this.getSkuList('') //初始查询表数据   
 
    },
    components: {
 
    },
    mounted () {  
        getBaseData(this.v_url,'MODELNO','PRD','CORPID',this.v_corpid,'V_BS_MAT','').then(res=>{
            this.prdArr =res.result
        }) 
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
        this.$refs.refqry.focus()
         //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username ,'frmidseq','227473','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                console.log(JSON.stringify(row))
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
    } ,
    computed: {
        tabHeight() {
          return  window.innerHeight -190
        },
 
        dlgWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
    },
    methods: {  
        matChg(val){
            this.formCol['MATNM']=''
            this.formCol['MATDESC']=''
            this.prdArr.some(item=>{
                if(item['IDNO']==val){
                    this.formCol['MATNM']=item['MATNM']
                    this.formCol['MATDESC']=item['MATDESC']
                }
            })
        },
        addRec(){
            this.initWin =true
            this.formCol={}
        },
        saveRec(){
            //发起保存请求   
            if (this.formCol['MATNO']) { 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.formCol,{ CORPID:this.v_corpid } ) ), p_table:'SKU_INIT',p_frmid:''},
                }).then(res=>{    
                    if(res.code ==='200')  {     
                        this.initWin =false   
                        this.getSkuList('')         
                    }else{
                        if (res.result.indexOf('ORA-00001')>-1){
                            this.prompt ='已存在相同的产品编码，请核查'
                            this.promptWin=true   
                        }else{
                            this.prompt=res.result
                            this.promptWin=true
                        }
                    }        
                }) 
            }else{
                this.prompt='产品编码不能为空'
                this.promptWin=true
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.dtlData = this.allData.slice(_start,_end);
        },
 
        editRec(row){
            this.initWin =true
            this.formCol =JSON.parse(JSON.stringify(row))
        },
        dtlRec(row){
            this.chkWin =true
            this.chkCol =JSON.parse(JSON.stringify(row))
        },
        getRowKey(row){
            return row.PKSEQ
        },
 
        //查询表格数据
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            if (this.selparam2&& this.txtparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                }
            }
            this.getSkuList(cond_ )
        },
 
        //获取表单数据
        getSkuList(cond){
            var vm=this
            this.loading =true
            getTabColOrData(this.v_formurl,'v_SKU_init','corpid',this.v_corpid,'','','','',cond+' order by adddttm desc').then((res) => {              
                if (res.code==='200'){
                    this.tmpData=res.result  
                    if (res.result.length>0)
                    this.$refs['reftab'].setCurrentRow(res.result[0])  
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                vm.loading =false         
            });            
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227473','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
 
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .item-width2  {
        width: 97%;
    } 
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
